export default __webpack_public_path__ + "static/media/Dinnerwithstars.adf9decc.svg";